import { Avatar } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../constants/themeProvider';

function CUserImageIcon(props) {
    const { src } = props;
    const theme = useTheme();
    let imageUrl = src || '';
    return (
        <Avatar src={imageUrl} style={{ backgroundColor: imageUrl ? null : theme?.primaryColor }} className="my-image"/>
    );
}

CUserImageIcon.propTypes = {
    src: PropTypes.string
};

export default CUserImageIcon;
